export default __webpack_public_path__ + "static/media/Vector1.96e3d143.svg";